import api from "../../../Services/api";

export const fetchUserAssignedCreatedForms = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    if (!userData || !userData.id) {
      console.error("User data not found in localStorage");
      return [];
    }
    const userIdStr = String(userData.id);

    const [userCreated, allForms] = await Promise.all([
      fetchUserForms(),
      fetchForms(),
    ]);

    const assignedOrCreatedFromAll = Array.isArray(allForms)
      ? allForms.filter((f) => {
          if (!f) return false;
          const assignedMatch =
            Array.isArray(f.assignedTo) &&
            f.assignedTo.map((a) => String(a)).includes(userIdStr);
          const createdMatch = String(f.createdBy) === userIdStr;
          return assignedMatch || createdMatch;
        })
      : [];

    const map = new Map();
    (Array.isArray(userCreated) ? userCreated : []).forEach((f) => {
      if (f && f.id) map.set(String(f.id), f);
    });
    (Array.isArray(assignedOrCreatedFromAll)
      ? assignedOrCreatedFromAll
      : []
    ).forEach((f) => {
      if (f && f.id) {
        const idStr = String(f.id);
        if (!map.has(idStr)) map.set(idStr, f);
      }
    });
    return Array.from(map.values());
  } catch (error) {
    console.error("Error fetching merged user assigned/created forms:", error);
    throw error;
  }
};

export const fetchUserForms = async () => {
  try {
    // Get user data from localStorage and ensure it exists
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");

    // Check if userData and id exist
    if (!userData || !userData.id) {
      console.error("User data not found in localStorage");
      return [];
    }

    // Convert userId to string explicitly to match backend expectations
    const userId = String(userData.id);

    // Fetch forms assigned to the current logged-in user
    const response = await api.get(`/forms/user/${userId}`);
    return response.data.forms || [];
  } catch (error) {
    console.error("Error fetching user forms:", error);
    // If 403 or 204, it's not a critical error, just return empty forms
    if (
      error.response &&
      (error.response.status === 403 || error.response.status === 204)
    ) {
      return [];
    }
    throw error;
  }
};

export const fetchForms = async () => {
  try {
    const response = await api.get("/forms/all", {
      data: {},
    });
    return response.data.forms;
  } catch (error) {
    console.error("Error fetching forms:", error);
    throw error;
  }
};

export const fetchFilledforms = async () => {
  try {
    // Get user data from localStorage
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");

    // Check if userData and id exist
    if (!userData || !userData.id) {
      console.error("User data not found in localStorage");
      return [];
    }

    const response = await api.get("/filled-forms/all", {
      data: {},
    });

    // Filter filled forms where submissionId matches user's ID
    const userFilledForms = response.data.filledForms.filter(
      (form) => form.submissionId === userData.id
    );

    return userFilledForms;
  } catch (error) {
    console.error("Error fetching filledForms:", error);
    throw error;
  }
};

export const updateStatus = async (formId, status) => {
  try {
    const response = await api.put(`/forms/toggle-status/${formId}`, {
      status,
    });
    return response.data.form;
  } catch (error) {
    console.error("Error updating form status:", error);
    throw error;
  }
};

export const handleHardDeleteForm = async (formId) => {
  try {
    const response = await api.delete(`/forms/delete/${formId}`);
    return response.data.form;
  } catch (error) {
    console.error("Error deleting form:", error);
    throw error;
  }
};

export const handleSoftDeleteForm = async (formId) => {
  try {
    const response = await api.put(`/forms/toggle-soft-delete/${formId}`);
    return response.data.form;
  } catch (error) {
    console.error("Error soft deleting form:", error);
    throw error;
  }
};

export const handleResetForm = async (formId) => {
  try {
    const response = await api.delete(`/filled-forms/reset/${formId}`);
    return response.data.form;
  } catch (error) {
    console.error("Error resetting form:", error);
    throw error;
  }
};
